export const API_BASE_PATH = "https://frontend.nogrunt.com";
export const API_BASE_RELATIVE_PATH = "/KeyLogging/ReactApp";
export const FORGE_IAM_ACCESS_TOKEN_KEY = "";
export const API_TIMEOUT = 60000;
export const mock_Data = "!mock";
export const API_BACKEND_URL = "https://ai.nogrunt.com/api";
export const TEST_CASE_GENERATION_URL = "https://gentc.nogrunt.com";

